var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.722 16.191a6.722 6.722 0 00-13.444 0v1.134h13.445zm-7.588-7.83h1.732a.249.249 0 00.247-.303l-.664-2.714a.465.465 0 00-.898 0l-.664 2.713a.249.249 0 00.247.304zm-5.292 2.91l1.224-1.225a.249.249 0 00.007-.351.246.246 0 00-.047-.039L8.638 8.208a.465.465 0 00-.635.635l1.449 2.388a.249.249 0 00.39.04zm-1.685 5.8v-1.732a.249.249 0 00-.304-.248l-2.713.665a.465.465 0 000 .897l2.713.665a.248.248 0 00.304-.247zm15.686-1.732v1.732a.249.249 0 00.244.253.244.244 0 00.06-.006l2.713-.664a.465.465 0 000-.898l-2.713-.665a.248.248 0 00-.304.248zm-2.91-5.292l1.225 1.224a.249.249 0 00.39-.04l1.449-2.388a.465.465 0 00-.635-.635l-2.388 1.448a.249.249 0 00-.078.343.246.246 0 00.038.047z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--sun-half-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'SunHalfCircleIcon';
export default Icon;